import classNames from 'classnames';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMemoFormContext } from '../context/FormContext';
import { FormMode } from '../MemoForm';

interface SubmitBtnProps {
  onClick?: () => void;
}

export const SubmitBtn: React.FC<SubmitBtnProps> = ({ onClick }) => {
  const {
    mode,
    formState: { isValid },
    isSubmitting,
  } = useMemoFormContext();

  // Determine button text based on form mode and submission state
  const getButtonText = () => {
    const isEditMode = mode === FormMode.Edit;

    if (isSubmitting) {
      return isEditMode ? 'Saving...' : 'Creating...';
    } else {
      return isEditMode ? 'Save' : 'Create';
    }
  };

  const buttonText = getButtonText();

  return (
    <button
      type="submit"
      onClick={onClick}
      disabled={!isValid || isSubmitting}
      className={styles.btn}
    >
      <span>{buttonText}</span>
      {!isSubmitting && (
        <FontAwesomeIcon icon={faArrowRight} className={styles.icon} />
      )}
    </button>
  );
};

const styles = {
  btn: classNames(
    'inline-flex items-center gap-2 px-4 py-2 border rounded-full border-transparent text-[13px] font-semibold',
    'shadow-xs text-white  active:bg-mf-blue-700 hover:bg-mf-blue-600 focus-visible:ring-2',
    'focus-visible:ring-accent-ink focus-visible:ring-offset-2 bg-accent-fill disabled:opacity-35',
  ),
  icon: 'text-[11px] font-semibold',
};
